import home from './src/home.vue'  //监控设备管理
import monitorInfo from './src/monitorInfo.vue' //监控设备管理详情

import realTimeVideo from './src/realTimeVideo/realTimeVideoGB.vue' //实时视频
import PlaybackVideo from './src/playBackVideo/PlaybackVideo.vue' //回放视频视频
import swiperVideoList from './src/swiperVideo/swiperVideoList.vue' //视频轮播列表

import PassengerflowView from './src/Passengerflow/PassengerflowView.vue'  //客流监测集成
import PassengerflowViewDaHua from './src/Passengerflow/PassengerflowViewDaHua.vue'  //客流监测集成大华
import PassengerflowViewGb from './src/Passengerflow/PassengerflowViewGb.vue'  //客流监测集成大华

import PlaybackVideoFlv from './src/playBackVideo/PlaybackVideoFlv.vue'
import swiperVideoFlv from './src/swiperVideo/swiperVideoFlv.vue' //视频轮播Flv



let views = {
    home,
    monitorInfo,
    realTimeVideo,
    PlaybackVideo,
    swiperVideoList,
    PassengerflowView,
    PassengerflowViewDaHua,
    PlaybackVideoFlv,
    swiperVideoFlv,
    PassengerflowViewGb
};

export default views;